import React, { useCallback } from "react";
import "./customTimeLine.css";

const CustomTimeLine = ({ timeLineItems, timeLineTitle }) => {
  const renderTimeLine = useCallback(() => {
    return !timeLineItems ? (
      ""
    ) : (
      <div className=" mt-2 mb-2">
        <div className="row">
          <div className="col-md-12 ">
            <h4>{timeLineTitle}</h4>
            <ul className="custom-timeline">
              {timeLineItems?.map((item, index) => {
                return (
                  <li key={index}>
                    <div className=" d-flex justify-content-between">
                      <div className=" fs-5 fw-bold">{item.title}</div>
                      <div className="text-muted">
                        <small> {item.subTitle}</small>
                      </div>
                    </div>
                    <p className="d-flex flex-wrap">{item.details}</p>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
    );
  }, [timeLineItems]);

  return renderTimeLine();
};

export default CustomTimeLine;
